<template>
  <!-- 进度条组件 -->
  <div class="relative w-full">
    <!-- 进度条背景线（绝对定位，贯穿整体） -->
    <div
      class="absolute left-0 right-0 h-[8px] z-0"
      :class="useCompactProgressBarTop ? 'top-[138px]' : 'top-[188px]'"
    >
      <!-- 灰色底色 -->
      <div class="absolute inset-0 bg-progress-gray rounded-full"></div>
      <!-- 橙色进度 -->
      <div
        class="absolute left-0 top-0 h-full bg-[#FF6900] rounded-full transition-all duration-300"
        :style="{ width: progressWidth }"
      ></div>
    </div>

    <!-- 进度条行 -->
    <div class="w-full flex justify-between">
      <div
        v-for="(milestone, index) in milestones"
        :key="milestone.days"
        class=" flex flex-col items-center"
      >
        <!-- 卡片 -->
        <div
          class="relative w-[145px] shadow-sm rounded-[12px] overflow-visible shrink-0"
          :class="hasReward(index) || isEnglish ? 'h-[161px]' : 'h-[111px]'"
        >
          <!-- 有奖励金额时：上半部分展示金额 -->
          <template v-if="hasReward(index)">
            <div
              class="h-[106px] w-full rounded-t-[12px] flex items-center justify-center relative overflow-hidden"
              :class="isReached(milestone) ? 'bg-[#FFF7E3]' : 'bg-[#F2F3F5]'"
            >
              <!-- 条纹背景 -->
              <div
                class="absolute inset-0"
                :class="
                  isReached(milestone) ? 'bg-stripe-orange' : 'bg-stripe-gray'
                "
              ></div>

              <!-- 金额 -->
              <div
                class="font-br-hendrix relative z-10 font-bold text-[52px] leading-none tracking-[-4px] mt-[10px]"
                :class="
                  isReached(milestone) ? 'text-[#5E2E00]' : 'text-[#333333]'
                "
              >
                {{ getTopContent(index) }}
              </div>
            </div>

            <!-- 虚线和缺口（有奖励时才展示分割线） -->
            <div
              class="absolute top-[100px] left-[-6px] w-[12px] h-[12px] rounded-full bg-white z-20"
            ></div>
            <div
              class="absolute top-[100px] right-[-6px] w-[12px] h-[12px] rounded-full bg-white z-20"
            ></div>
            <div
              class="absolute top-[106px] left-1/2 -translate-x-1/2 w-[127px] border-b-[2px] border-dashed border-white z-20 transform -translate-y-1/2"
            ></div>

            <!-- 下半部分：展示 rewardName -->
            <div
              class="h-[55px] w-full rounded-b-[12px] flex items-center justify-center relative overflow-hidden"
              :class="isReached(milestone) ? 'bg-[#FFC24C]' : 'bg-[#CCCCCC]'"
            >
              <!-- 中文：一行显示；英文：两行显示 -->
              <div
                class="text-center font-medium"
                :class="[
                  isReached(milestone) ? 'text-[#5E2E00]' : 'text-[#333333]',
                  isEnglish ? 'text-[20px] leading-[20px] whitespace-pre-line -mt-[20px]' : 'text-[21px] leading-[21px]'
                ]"
              >
                {{ getBottomContent(index) }}
              </div>
            </div>
          </template>

          <!-- 无奖励金额时：整个卡片区域展示 rewardName，布局随文案自然排列 -->
          <template v-else>
            <div
              class="relative w-full"
              :class="isEnglish ? 'h-[161px]' : 'h-[111px]'"
            >
              <div
                class="w-full rounded-[12px] flex items-center justify-center relative overflow-hidden"
                :class="[
                  isEnglish ? 'h-[161px]' : 'h-[111px]',
                  isReached(milestone)
                    ? 'bg-[linear-gradient(180deg,#FFDB7C_0%,#FFECC0_80%)]'
                    : 'bg-[#CCCCCC]'
                ]"
              >
                <!-- 奖励名称（全卡片居中展示） -->
                <div
                  class="relative z-10 text-center font-medium px-[8px]"
                  :class="[
                    isReached(milestone) ? 'text-[#5E2E00]' : 'text-[#333333]',
                    isEnglish ? 'text-[0.25rem] leading-[0.3rem] whitespace-pre-line' : 'text-[0.25rem] leading-[0.3rem]'
                  ]"
                  v-html="getBottomContent(index)"
                ></div>
              </div>

              <!-- 底部小箭头 -->
              <div
                class="absolute left-1/2 -translate-x-1/2 -bottom-[6px] w-[12px] h-[12px] rotate-45"
                :class="[
                  isReached(milestone) ? 'bg-[#FFECC0]' : 'bg-[#CCCCCC]',
                ]"
              ></div>
            </div>
          </template>
        </div>

        <!-- 间距占位符 -->
        <div class="h-[20px] w-full shrink-0"></div>

        <!-- 进度条圆点 -->
        <div class="w-full flex items-center justify-center h-[22px] relative">
          <!-- 圆点 -->
          <div
            class="w-[25.5px] h-[25.5px] rounded-full flex items-center justify-center z-10"
            :class="
              isReachedStreak(milestone) ? 'bg-[#FF6900]' : 'bg-progress-gray'
            "
          >
            <div
              class="w-[22px] h-[22px] rounded-full border-solid border-[3px] box-border bg-white"
              :class="
                isReachedStreak(milestone)
                  ? 'border-[#FF6900]'
                  : 'border-progress-gray'
              "
            ></div>
          </div>
        </div>

        <!-- 间距占位符 -->
        <div class="h-[8px] w-full shrink-0"></div>

        <!-- 天数 -->
        <div
          class="leading-none text-[#1D2129]  "
          :class="isEnglish ? 'text-[22px] tracking-[-0.02em]' : 'text-[26px]'"
        >
          {{ formatDays(milestone.days) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import { lang } from '../utils/lang';
import $t from '../utils/i18n';
import { ELang } from '@ark/utils';
import { formatRewardAmount } from '../utils/format-reward';
import { CurrencyEnum } from '@ark/utils';
interface Milestone {
  days: number;
  reward?: number;
  rewardName?: string;
  claimed: boolean;
}
interface Props {
  milestones: Milestone[];
  currentStreak: number;
  currency: keyof typeof CurrencyEnum.KV;
}
const __sfc_main = {};
__sfc_main.props = {
  milestones: {
    key: "milestones",
    required: true,
    type: Array
  },
  currentStreak: {
    key: "currentStreak",
    required: true,
    type: Number
  },
  currency: {
    key: "currency",
    required: true,
    type: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;

  // 语言判断
  const isEnglish = computed(() => lang === ELang.KV.EN);

  // 中文且存在无奖励金额卡片时，进度条上移以贴合 111px 卡片高度
  const useCompactProgressBarTop = computed(() => {
    if (isEnglish.value) return false;
    return props.milestones.some(milestone => !milestone.reward || milestone.reward <= 0);
  });

  // 获取多语言文案（使用 computed 确保响应式）
  const optionCashCouponText = computed(() => $t('Milestone.optionCashCoupon'));
  const daysTemplate = computed(() => $t('Milestone.days'));

  // 格式化天数文案
  function formatDays(days: number): string {
    return daysTemplate.value.replace('{n}', String(days));
  }

  /**
   * 该里程碑是否配置了奖励金额（rewardValue > 0）
   */
  function hasReward(index: number): boolean {
    const milestone = props.milestones[index];
    return milestone?.reward != null && milestone.reward > 0;
  }

  /**
   * 获取卡片上半区内容（金额文字）
   * - 有 reward（> 0）：返回格式化金额字符串
   * - 无 reward：返回空字符串（调用方通过 hasReward 控制是否渲染）
   */
  function getTopContent(index: number): string {
    const milestone = props.milestones[index];
    if (!milestone || milestone.reward == null || milestone.reward <= 0) return '';
    return formatRewardAmount(props.currency, milestone.reward);
  }

  /**
   * 获取卡片下半区内容（奖励名称）
   * 优先使用配置的 rewardName，否则降级使用默认文案
   */
  function getBottomContent(index: number): string {
    const milestone = props.milestones[index];
    if (milestone?.rewardName) {
      return milestone.rewardName;
    }
    // 降级使用默认文案
    return optionCashCouponText.value;
  }
  function isReached(milestone: Milestone): boolean {
    return milestone.claimed;
  }
  function isReachedStreak(milestone: Milestone): boolean {
    return props.currentStreak >= milestone.days;
  }
  const progressWidth = computed(() => {
    const len = props.milestones.length;
    if (len === 0) return '0%';

    // 1. 找到当前进度所在的区间
    const streak = props.currentStreak;
    const milestones = props.milestones;

    // 每个里程碑圆点的中心位置百分比
    // item 宽度是 100/len
    // 中心位置是 (i + 0.5) * (100/len)
    const centers = milestones.map((_, i) => (i + 0.5) * (100 / len));

    // 如果进度小于第一个里程碑
    if (streak < milestones[0].days) {
      // 进度比例：streak / days
      // 宽度 = centers[0] * ratio
      // 注意：这意味着从最左边(0%)开始算。如果 streak=0, width=0。
      const ratio = Math.max(0, streak) / milestones[0].days;
      return `${centers[0] * ratio}%`;
    }

    // 如果进度超过最后一个里程碑
    if (streak >= milestones[len - 1].days) {
      return '100%';
    }

    // 在中间区间
    for (let i = 0; i < len - 1; i++) {
      const startDays = milestones[i].days;
      const endDays = milestones[i + 1].days;
      if (streak >= startDays && streak < endDays) {
        const startPos = centers[i];
        const endPos = centers[i + 1];
        const ratio = (streak - startDays) / (endDays - startDays);
        return `${startPos + (endPos - startPos) * ratio}%`;
      }
    }
    return '0%';
  });
  return {
    isEnglish,
    useCompactProgressBarTop,
    formatDays,
    hasReward,
    getTopContent,
    getBottomContent,
    isReached,
    isReachedStreak,
    progressWidth
  };
};
export default __sfc_main;
</script>

<style scoped>
.bg-progress-gray {
  background-color: #e5e5e5;
}

.border-progress-gray {
  border-color: #e5e5e5;
}

.bg-stripe-orange {
  background-image: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 4px,
    rgba(255, 160, 0, 0.1) 4px,
    rgba(255, 160, 0, 0.1) 8px
  );
}

.bg-stripe-gray {
  background-image: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 4px,
    rgba(0, 0, 0, 0.05) 4px,
    rgba(0, 0, 0, 0.05) 8px
  );
}

.font-din {
  font-family: 'MiSans', sans-serif;
}

.font-br-hendrix {
  font-family: 'BR Hendrix', sans-serif;
}
</style>
